import { h, Component } from "preact";
import { Text } from "preact-i18n";

class Welcome extends Component {
    render() {
        //const { registerLink } = this.props;

        return (
            <div class="imagifyC" style={{ minHeight: "100%" }} id="home">
                <div class="uk-container">

                    <div
                        uk-grid
                        uk-scrollspy="cls: uk-animation-fade; repeat: true"
                        class="uk-grid-large uk-flex-middle uk-text-center uk-text-left@l uk-grid"
                    >
                        <div class="uk-width-2-3@l uk-first-column" style="padding-top: 200px">
                            
                            <h5 style="color:#FCFDFE">
                                <Text id="Welcome.pre-title">
                                    Formação em: Agricultura Inteligente / Agricultura de Precisão
                                </Text>
                            </h5>

                            <h2 style="color:#FCFDFE">
                                <Text id="Welcome.title">
                                    Agroinsider apoia a formação em Novas Tecnologias na Agricultura.
                                </Text>
                            </h2>

                            <h3 style="color:#FCFDFE">
                                <Text id="Welcome.subtitle">
                                    Construindo o futuro do 'Prado ao Prato'
                                </Text>
                            </h3>

                            <h4 style="color:#FCFDFE">
                                <Text id="Welcome.text">
                                    Tenha acesso a conhecimentos relevantes de como usar as novas tecnologias 
                                    na agricultura por forma a maximizar o retorno económico imediato, bem como, 
                                    reduzir os impactos ambientais da sua atividade tornando o seu negócio mais 
                                    resiliente e conforme com os objetivos do “Green Deal” europeu.
                                </Text>
                            </h4>

                            <div
                                uk-grid=""
                                class="uk-grid-medium uk-flex-center uk-grid"
                            >

                                <div class="uk-first-column">
                                    <a
                                        href="#contactus"
                                        style={{ float: "left", paddingRight: "1em" }}
                                    >
                                        <button
                                            class="uk-button uk-button-primary uk-width-6-6 uk-margin-small-bottom"
                                        >
                                            <Text id="App.register">Registar-se</Text>
                                        </button>
                                    </a>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
                <div style={{ clear: "both" }}></div>

            </div>
        );
    }
}

export default Welcome;
